// extracted by mini-css-extract-plugin
export default {"confirmModal":"styles_confirmModal__T5ODo","modalTitle":"styles_modalTitle__wdzbu","buttons":"styles_buttons__kGmZf"};